import {Link} from "react-router-dom";
import {indicesDetailsUrl} from "../../../Route_urls";
import CountryFlag from "../../CountryFlag/CountryFlag";
import Spacer from "../../Spacer";
import Typography from "@mui/material/Typography";
import ColorNumber from "../../ColorNumber/ColorNumber";
import Loader from "../../Loader/Loader";
import {InView} from "react-intersection-observer";

const TEXT = {
    dayHigh: "Day high",
    dayLow: "Day low",
    current: "Current",
    changeDayPerc: "Change day %",
    changeDayNum: "Change day"
}
const IndexListCard = ({fetchedStockList, hasNextPage, scrollLock, getMoreStocks}) => {
    return (
        <div className="stockList">
            {fetchedStockList && fetchedStockList.map(({node: stock}) => (
                <Link
                    className="block w-screen my-1.5 sm:mx-1.5  lg:w-96 md:w-96   bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700"
                    style={{textDecoration: 'none'}} key={stock?.indexId}
                    to={`${indicesDetailsUrl}/${stock.swedishIndex.slug}`}
                    state={{stockData: stock}}>

                    <div className="stockCard">
                        <div className="mainData">
                            <CountryFlag countryName={stock.swedishIndex.country}/>
                            <Spacer axis="horizontal" size={15}/>
                            <Typography sx={{fontWeight: 900}}>
                                {stock.swedishIndex.indexCustomName}
                            </Typography>
                        </div>
                        <Spacer axis="vertical" size={10}/>
                        <div className="secondaryData">
                            <div className='dataPart'>
                                <div className="dataBoxSmall">
                                    <div className="smallTitle">
                                        <Typography>
                                            {TEXT.dayHigh}
                                        </Typography>
                                    </div>
                                    <div className="standardText">
                                        <Typography>
                                            {stock.highPrice}
                                        </Typography>
                                    </div>
                                </div>
                                <div className="dataBoxSmall">
                                    <div className="smallTitle">
                                        <Typography>
                                            {TEXT.dayLow}
                                        </Typography>
                                    </div>
                                    <div className="standardText">
                                        <Typography>
                                            {stock.lowPrice}
                                        </Typography>
                                    </div>

                                </div>
                                <div className="dataBoxSmall">
                                    <div className="smallTitle">
                                        <Typography>
                                            {TEXT.current}
                                        </Typography>
                                    </div>
                                    <div className="oneRow">
                                        <div className="standardText">
                                            <Typography>
                                                {stock.currentPrice}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Spacer axis="vertical" size={8}/>

                        <div className="secondaryData">
                            <div className='dataPart'>
                                <div className="dataBoxSmall">
                                    <div className="smallTitle">
                                        <Typography>
                                            {TEXT.changeDayPerc}
                                        </Typography>
                                    </div>
                                    <div className="standardText">
                                        <Typography>
                                            <ColorNumber number={stock.changePercentageLastDay}
                                                         endSign={'%'}/>
                                        </Typography>
                                    </div>
                                </div>
                                <div className="dataBoxSmall">
                                    <div className="smallTitle">
                                        <Typography>
                                            {TEXT.changeDayNum}
                                        </Typography>
                                    </div>
                                    <div className="standardText">
                                        <Typography>
                                            <ColorNumber number={stock.changeLastDay} endSign={''}/>
                                        </Typography>
                                    </div>

                                </div>

                            </div>

                        </div>


                    </div>
                </Link>
            ))}
            {hasNextPage && <Loader/>}

            <InView
                onChange={async (inView) => {
                    if (inView) {
                        !scrollLock && getMoreStocks()
                    }
                }}
            />
        </div>
    )
}

export default IndexListCard